module.exports = "/React/dist/5c3ce10f328c2c6f05917d12d2aa83e6.png";